import React from "react";
import store from "../../../Store";
import getDiscounts from "../../../ajax/actions/discount-slab/discount_gets";
import { resetDiscountParams } from "./Discount-Action";

class DiscountWorker extends React.Component {
  componentDidMount() {
    store.dispatch(resetDiscountParams());
    store.dispatch(getDiscounts());
  }

  render() {
    return null;
  }
}

export default DiscountWorker;
